<div>
	<span *ngFor="let breadcrumb of breadcrumbs;">
		<span [ngClass]="currentRoute === breadcrumb.url ? 'color-black' : 'color-grey'">
			<span *ngIf="breadcrumb.url.includes('details')" class="bread-crumb">
				{{  breadcrumb.label }}
			</span>
			<span *ngIf="!(breadcrumb.url.includes('details'))" [routerLink]="breadcrumb.url" class="bread-crumb">
				{{ "global.breadcrumb." + breadcrumb.label | translate }}
			</span>
			<span>
				{{ "/" }}
			</span>
		</span>
	</span>
</div>
